export default __webpack_public_path__ + "assets/images/5ef6b9b5eb1da30f3cc8fbfc8ce7c858.png";